import React from 'react'
import {
  DataObjectId,
  getWorkflowFieldFromState,
  Workflow,
  Workflows,
  workflowToConfig
} from 'yougile-model'
import {UserAvatar} from '@components/user-avatar'
import {UserName} from '@components/user-name'
import {WorkflowStateProps} from './in-workflow'

const FieldValue = (props: Props & {field: Workflows.Field}): JSX.Element => {
  const {workflowState, workflow, field} = props
  if (field.type === 'users') {
    return (
      <div>
        {(
          getWorkflowFieldFromState(
            workflow,
            workflowState,
            field
          ) as DataObjectId[]
        ).map((uid: DataObjectId) => {
          return (
            <div key={uid}>
              <UserAvatar userId={uid} size={20} />

              <UserName className="ml-4" userId={uid} />
            </div>
          )
        })}
      </div>
    )
  }
  return <div>{getWorkflowFieldFromState(workflow, workflowState, field)}</div>
}

const FieldItem = (props: Props & {field: Workflows.Field}): JSX.Element => {
  const {field} = props
  return (
    <div className="flex ">
      <div className="text-third-old mr-8">{field.name}:</div>
      <FieldValue {...props} />
    </div>
  )
}

type Props = WorkflowStateProps & {workflow: Workflow}

export const FieldsInTask = (props: Props): JSX.Element => {
  const {workflow} = props
  const config = workflowToConfig(workflow)
  return (
    <div className="my-16">
      {config.fields?.map(field => (
        <FieldItem key={field.name} {...props} field={field} />
      ))}
    </div>
  )
}
